import { MintRequestDto } from "../../cityversetycoon/networking/data/responses/MintRequestDto";
import { ObjectFieldsChecker } from "../../tools/ObjectFieldsChecker";


export class MintRequest {
    public readonly signature: `0x${string}`;
    public readonly payload: {
        currency: string,
        pricePerToken: bigint,
        primarySaleRecipient: string,
        royaltyBps: bigint,
        royaltyRecipient: string,
        to: string,
        quantity: bigint,
        uid: `0x${string}`,
        uri: string,
        tokenId: bigint,
        validityEndTimestamp: bigint,
        validityStartTimestamp: bigint
    }

    public constructor(mintRequestDto: MintRequestDto) {
        this.validateDto(mintRequestDto);
        this.signature = mintRequestDto.signature as `0x${string}`;
        this.payload = {
            currency: mintRequestDto.request.currency,
            pricePerToken: BigInt(mintRequestDto.request.pricePerToken),
            primarySaleRecipient: mintRequestDto.request.primarySaleRecipient,
            quantity: BigInt(mintRequestDto.request.quantity),
            royaltyBps: BigInt(mintRequestDto.request.royaltyBps),
            royaltyRecipient: mintRequestDto.request.royaltyRecipient,
            to: mintRequestDto.request.to,
            tokenId: BigInt(mintRequestDto.request.tokenId),
            uid: mintRequestDto.request.uid as `0x${string}`,
            uri: mintRequestDto.request.uri ?? "",
            validityEndTimestamp: BigInt(Math.floor(new Date(mintRequestDto.request.validityEndTimestamp).getTime() / 1000)),
            validityStartTimestamp: BigInt(Math.floor(new Date(mintRequestDto.request.validityStartTimestamp).getTime() / 1000))
        }
    }

    private validateDto(mintRequestDto: MintRequestDto) {
        ObjectFieldsChecker.throwIfInvalidFields(mintRequestDto, ["request", "signature"], "mintRequestDto");
        ObjectFieldsChecker.throwIfInvalidFields(mintRequestDto.request, [
            "currency",
            "pricePerToken",
            "primarySaleRecipient",
            "quantity",
            "royaltyBps",
            "royaltyRecipient",
            "to",
            "tokenId",
            "uid",
            "validityEndTimestamp",
            "validityStartTimestamp"
        ], "mintRequestDto.request");
    }
}